import { render, staticRenderFns } from "./JgpQuery.vue?vue&type=template&id=1cf27f0d&"
import script from "./JgpQuery.vue?vue&type=script&lang=js&"
export * from "./JgpQuery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports